import { render, staticRenderFns } from "./Complaints.vue?vue&type=template&id=506fff9c&scoped=true"
import script from "./Complaints.vue?vue&type=script&lang=js"
export * from "./Complaints.vue?vue&type=script&lang=js"
import style0 from "./Complaints.vue?vue&type=style&index=0&id=506fff9c&prod&scoped=true&lang=css"
import style1 from "./Complaints.vue?vue&type=style&index=1&id=506fff9c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "506fff9c",
  null
  
)

export default component.exports